import React, { useState } from "react";
import {
    faPencil,
    faPlus,
    faTrash,
    faXmark,
    faLock,
    faLockOpen,
} from "@fortawesome/free-solid-svg-icons";
import { faShare } from "@fortawesome/free-solid-svg-icons/faShare";
import { useTranslation } from "react-i18next";

import "./TaskListHeader.css";
import { TaskHeaderView } from "./task-header-view/TaskHeaderView";
import { TaskHeaderEdit } from "./task-header-edit/TaskHeaderEdit";
import { ConfirmationDialog } from "../confirmation-dialog/ConfirmationDialog";
import { faGripVertical } from "@fortawesome/free-solid-svg-icons/faGripVertical";

export const TaskListHeader = ({
    listName,
    updateListName,
    shareCollection,
    onDeleteList,
    showReorderHandles = false,
    onToggleReorderHandles,
    onAddSection,
    canDeleteCollection = true,
    isSecret = false,
    onToggleSecret,
}) => {
    const { t } = useTranslation();
    const [isEditing, setIsEditing] = useState(false);
    const [header, setHeader] = useState("");
    const [showDeleteConfirmationDialog, setShowDeleteConfirmationDialog] =
        useState(false);
    const actions = [
        ...(onToggleSecret ? [{
            label: t(isSecret ? 'secretCollections.makeRegular' : 'secretCollections.makeSecret'),
            icon: isSecret ? faLockOpen : faLock,
            callback: onToggleSecret,
        }, { separator: true }] : []),
        {
            label: showReorderHandles
                ? t('taskListHeader.doneReorder')
                : t('taskListHeader.reorder'),
            icon: showReorderHandles ? faXmark : faGripVertical,
            callback: () => onToggleReorderHandles?.(),
        },
        { separator: true },
        {
            label: t('taskListHeader.shareCollection'),
            icon: faShare,
            callback: () => shareCollection(),
        },
        {
            label: t('taskListHeader.editCollectionName'),
            icon: faPencil,
            callback: () => handleEditClick(),
        },
        {
            label: t('sections.addSection'),
            icon: faPlus,
            callback: () => onAddSection?.(),
        },
    ];

    if (canDeleteCollection) {
        actions.push(
            { separator: true },
            {
                label: t('taskListHeader.deleteCollection'),
                icon: faTrash,
                callback: () => setShowDeleteConfirmationDialog(true),
            },
        );
    }

    const handleSave = () => {
        if (header.trim()) {
            updateListName(header);
            setIsEditing(false);
            setHeader("");
        }
    };

    const handleEditClick = () => {
        setHeader(listName);
        setIsEditing(true);
    };

    const handleDeleteConfirmation = () => {
        setShowDeleteConfirmationDialog(false);
        onDeleteList();
    };

    return (
        <div>
            {isEditing ? (
                <TaskHeaderEdit
                    header={header}
                    setHeader={setHeader}
                    handleSave={handleSave}
                />
            ) : (
                <TaskHeaderView listName={listName} actions={actions} />
            )}

            {showDeleteConfirmationDialog && (
                <ConfirmationDialog
                    title={t('taskListHeader.deleteCollectionTitle')}
                    message={t('taskListHeader.deleteCollectionConfirm')}
                    onConfirm={handleDeleteConfirmation}
                    onCancel={() => setShowDeleteConfirmationDialog(false)}
                    isDanger
                />
            )}
        </div>
    );
};
